// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1m8ee","button-primary":"styles_button-primary__bmVTU","button-secondary":"styles_button-secondary__r63Cl"};